<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
></ngx-loading>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: rgb(255, 250, 244)">
    <mat-toolbar class="pageHeader">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <h3>CTVET Attendance & Course Tracker / Register</h3>
    </mat-toolbar>
    <!-- Add Content Here -->
    <div class="content-body">
      <div class="main-panel">
        <div class="content-wrapper">
          <!-- Page Title Header Starts-->
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <form #studentForm="ngForm" (ngSubmit)="onSubmit(studentForm)">
                            <div class="form-group">
                              <label for="studentName">Name:</label>
                              <input 
                                type="text" 
                                class="form-control" 
                                id="studentName" 
                                [(ngModel)]="fullname" 
                                name="fullname" 
                                required 
                                placeholder="Enter student name"
                              />
                            </div>
                            
                            <div class="form-group">
                              <label for="vmsId">VMS ID:</label>
                              <input 
                                type="text" 
                                class="form-control" 
                                id="vmsId" 
                                [(ngModel)]="vmsId" 
                                name="vmsId" 
                                required 
                                placeholder="Enter VMS ID"
                              />
                            </div>
                          
                            <div class="form-group">
                              <label for="date">Date:</label>
                              <input 
                                type="date" 
                                class="form-control" 
                                id="date" 
                                [(ngModel)]="date" 
                                name="date" 
                                required
                              />
                            </div>
                          
                            <div class="form-group">
                              <label for="courseName">Course:</label>
                              <select 
                                class="form-control" 
                                id="courseName" 
                                [(ngModel)]="selectedCourse" 
                                name="courseName" 
                                required
                              >
                                <option [ngValue]="null" disabled>Select a course</option>
                                <option *ngFor="let course of courses" [ngValue]="course">
                                  {{ course.name }}
                                </option>
                              </select>
                            </div>
                          
                            <div class="form-group">
                              <label for="group">Group:</label>
                              <select 
                                class="form-control" 
                                id="group" 
                                [(ngModel)]="group" 
                                name="group" 
                                required
                              >
                                <option value="" disabled selected>Select a group</option>
                                <option value="A">A</option>
                                <option value="B">B</option>
                                <option value="C">C</option>
                                <option value="D">D</option>
                                <option value="E">E</option>
                              </select>
                            </div>
                          
                            <div class="form-group-btn mt-3">
                              <button 
                                type="submit" 
                                class="btn btn-primary btn-block" 
                                [disabled]="!studentForm.valid"
                              >
                                Submit
                              </button>
                            </div>
                          </form>
                          
                    </div>
                  </div>
            </div>
            </div>        
         

        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>






